import { createContext } from 'react';

import { AppConfigErrorScreen } from '../features/app-config/app-config-error-screen/app-config-error-screen';
import { useShouldUseCdmMode } from '../hooks/use-should-use-cdm-mode';

import { CdmRoutes } from './cdm-routes';
import { PageLoader } from './page-loader/page-loader';
import { Routes } from './routes';

export interface AppRoutesContextInterface {
  useShouldUseCdmMode: typeof useShouldUseCdmMode;
  PageLoader: typeof PageLoader;
  AppConfigErrorScreen: typeof AppConfigErrorScreen;
  CdmRoutes: typeof CdmRoutes;
  Routes: typeof Routes;
}

const defaultValue: AppRoutesContextInterface = {
  useShouldUseCdmMode,
  PageLoader,
  AppConfigErrorScreen,
  CdmRoutes,
  Routes,
};

export const AppRoutesContext =
  createContext<AppRoutesContextInterface>(defaultValue);
